import ApolloClient from 'apollo-boost'

import { getEnvironmentVariable } from '../helpers'

const createRequest = ({ getAccessToken }) => async operation => {
  operation.setContext({
    headers: {
      Accept: 'application/json',
      accessToken: getAccessToken(),
    },
  })
}

const createApolloClient = ({ getAccessToken, resolvers }) =>
  new ApolloClient({
    uri: `${getEnvironmentVariable('REACT_APP_TP_API_URL')}/graphql`,
    request: createRequest({ getAccessToken }),
    resolvers,
  })

export default createApolloClient
